import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-fiber-edit-modal',
    template: `
        <mat-list
            class="max-h-64 overflow-auto justify-center"
            mat-dialog-content>
            <mat-list-item
                class="!cursor-pointer hover:bg-custom-grey"
                matRipple
                (click)="onDeleteFibering()">
                <span mat-line>{{ 'clearGrain' | transloco }}</span>
            </mat-list-item>
        </mat-list>
    `,
})
export class FiberEditModalComponent {
    private readonly dialogRef = inject(MatDialogRef<FiberEditModalComponent, boolean>);

    protected onDeleteFibering(): void {
        this.dialogRef.close(true);
    }
}
